import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from 'ha/services/apiV2/types/Listing';

interface Query {
  /**
   * @description comma-separated string with possible values: `exclusions`, `exclusionsExtended`, `bookablePeriods`, `conversationCounters`, `lastMonthConversationCount`, `videos`, `costs`
   */
  expand?: string;
  withPhotos?: string;
  withCroppedPhotos?: boolean;
  lang?: string;
  moveInDate?: string;
  moveOutDate?: string;
  bookinglink?: boolean;
}

export default (makeCall: MakeCall) => (listingId: number, query?: Query) =>
  makeCall<Listing>('GET', `/api/v2/listing/${listingId}`, {
    query,
  });
